import { render, staticRenderFns } from "./MarketingProductIframe.vue?vue&type=template&id=148fc7be&"
import script from "./MarketingProductIframe.vue?vue&type=script&lang=ts&"
export * from "./MarketingProductIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports